import { formatNumberToLocale } from "@utils/formatNumber";

// Resumo de títulos anulados que o `getDetail` entrega em `activeProject.titleAnnulments`
// (design D1/D6): { count, removedToPay, removedPaid, removedTotal, fromMeasurement,
// fromMeasurementDate, pending: { since, changedCount } | null, titles: [{ billId, titleNumber,
// wbsCodes, removedToPay, removedPaid }] (até 200) }. Valores em REAIS.

export const brl = (value) => `R$ ${formatNumberToLocale(Number(value) || 0)}`;

export const titleCount = (count) => `${count} ${count === 1 ? "título" : "títulos"}`;

export const isPending = (summary) => !!summary?.pending;

// Há o que mostrar: título anulado aplicado ou lista pendente de aplicação.
export const hasAnnulments = (summary) => !!summary && (Number(summary.count) > 0 || isPending(summary));

export const totalsOf = (summary) => {
  const toPay = Number(summary?.removedToPay) || 0;
  const paid = Number(summary?.removedPaid) || 0;
  return {
    count: Number(summary?.count) || 0,
    toPay,
    paid,
    total: Number.isFinite(Number(summary?.removedTotal)) && summary?.removedTotal != null
      ? Number(summary.removedTotal)
      : toPay + paid,
  };
};

const related = (code, itemCode) => code.startsWith(itemCode) || itemCode.startsWith(code);

// Um título conta para um item da EAP quando algum dos seus `wbsCodes` é o próprio item, um
// ancestral ou um descendente (prefixo do código da EAP).
export const matchingAnnulledTitles = (titles, wbsCode) => {
  const itemCode = String(wbsCode ?? "");
  if (!itemCode || !Array.isArray(titles)) return [];
  return titles.filter((title) => (Array.isArray(title?.wbsCodes) ? title.wbsCodes : [])
    .some((code) => code != null && String(code) !== "" && related(String(code), itemCode)));
};

// Para um item da EAP: só os títulos apropriados no item, em ancestrais ou em descendentes.
export const totalsForItem = (summary, wbsCode) => {
  const titles = matchingAnnulledTitles(summary?.titles, wbsCode);
  const toPay = titles.reduce((sum, title) => sum + (Number(title.removedToPay) || 0), 0);
  const paid = titles.reduce((sum, title) => sum + (Number(title.removedPaid) || 0), 0);
  return { count: titles.length, toPay, paid, total: toPay + paid };
};

export const PENDING_TEXT = "A lista de títulos anulados mudou. Atualize o financeiro para refletir nos valores.";
export const PENDING_BANNER_TITLE = "Atualização do financeiro pendente";
export const PENDING_BANNER_TEXT = "A lista de títulos anulados mudou";
